import { useFieldError } from "Shared/Components/Form/Helpers/getFormErrors";
import CustomCheckbox from "Shared/Components/Inputs/CustomCheckbox";
import CustomFormLabel from "Shared/Components/Inputs/CustomFormLabel";
import {
	FormHelperText,
	type SxProps,
	type Theme,
	Typography,
} from "@mui/material";
import {
	type Control,
	Controller,
	type FieldError,
	type FieldErrors,
	type FieldPath,
	type FieldValues,
	get,
} from "react-hook-form";

interface CheckboxProps<FormType extends FieldValues> {
	id: string;
	name: FieldPath<FormType>;
	label?: string;
	control: Control<FormType, object>;
	errors: FieldErrors<{ tag: string; description: string }>;
	disabled?: boolean;
	sxLabel?: SxProps<Theme>;
	sx?: SxProps<Theme>;
	onChange?: (
		event: React.ChangeEventHandler<HTMLInputElement> | unknown,
	) => void;
}

const Checkbox = <T extends object>(props: CheckboxProps<T>) => {
	const { name, control, label, id, disabled, errors, sxLabel, sx, ...rest } =
		props;

	const { errorMessage } = useFieldError({
		fieldError: get(errors, name) as FieldError,
	});

	return (
		<>
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange, value = false, onBlur } }) => (
					<>
						{label && (
							<CustomFormLabel htmlFor={id} sx={sxLabel}>
								{label}
							</CustomFormLabel>
						)}
						<CustomCheckbox
							id={id}
							checked={value}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
								onChange(e.target.checked);
								rest.onChange?.(e.target.checked);
							}}
							onBlur={onBlur}
							name={name.toString()}
							disabled={disabled}
							{...rest}
							sx={{
								display: "flex",
								justifyContent: "flex-start",
								paddingRight: 0,
								paddingLeft: 0,
								...sx,
							}}
						/>
						{true && (
							<FormHelperText sx={{ ml: "1rem", mt: "3px", mb: 2 }}>
								<Typography color="error" variant="caption">
									{errorMessage}
								</Typography>
							</FormHelperText>
						)}
					</>
				)}
			/>
		</>
	);
};

export default Checkbox;
